import { render, staticRenderFns } from "./tabSubscriptions.vue?vue&type=template&id=64a3ab08&scoped=true"
import script from "./tabSubscriptions.vue?vue&type=script&lang=js"
export * from "./tabSubscriptions.vue?vue&type=script&lang=js"
import style0 from "./tabSubscriptions.vue?vue&type=style&index=0&id=64a3ab08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a3ab08",
  null
  
)

export default component.exports